<template>
  <form method="post" action="/api/invoice/update" class="text-left my-4">
    <input type="hidden" name="invoice[id]" v-model="invoice.id" />

    <div class="row mb-4 text-sm">
      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Policyholder Name</label>
              <div class="form-control-wrap">
                {{ placement.policyholder.name ? placement.policyholder.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster</label>
              <div class="form-control-wrap">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.contact_data ? adjusters.public_adjuster.contact_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster Company</label>
              <div class="form-control-wrap">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.company_data ? adjusters.public_adjuster.company_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" v-if="placement.loss_address && placement.loss_address.full_address">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Loss Address</label>
              <div class="form-control-wrap">
                {{ placement.loss_address.full_address }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" v-if="property && property.address && property.address.full_address">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Relocation Address</label>
              <div class="form-control-wrap">
                {{ property.address.full_address }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-5"></div>

        <div class="form-row mb-2" v-if="invoice.created_from === 'hotel_placement'">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Hotel Name</label>
              <div class="ml-3 justify-content-between">
                <strong>{{ hotel.name || "-" }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Invoice Number</label>
              <div class="ml-3 justify-content-between">
                <strong>{{ invoice.invoice_number || "-" }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Amount</label>
              <div class="ml-3 justify-content-between">
                <strong>${{ formatMoney(invoice.amount) || "0.00" }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-5"></div>

        <div class="form-row mb-2 align-items-start">
          <div class="col">
            <div class="row">
              <div class="col-12">
                <label class="tps-checkbox">
                  <input type="radio" value="Partially Paid" name="invoice[status]" v-model="invoice.status" />
                  <span class="checkmark"></span>
                  <span class="label">Partially Paid</span>
                </label>
              </div>

              <div class="col-12 mt-3" v-if="invoice.status === 'Partially Paid'">
                <div class="form-group">
                  <label class="form-control-wrap">Amount Paid</label>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="invoice[partial_payment]"
                    v-model="invoice.partial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <label class="tps-checkbox">
              <input type="radio" value="IINK Processing" name="invoice[status]" v-model="invoice.status" />
              <span class="checkmark"></span>
              <span class="label">IINK Processing</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Insurance Company</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.name
                    ? adjusters.carrier_adjuster.company_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier Adjuster</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.name
                    ? adjusters.carrier_adjuster.contact_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Adjuster Preferences</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster &&
                  adjusters.carrier_adjuster.contact_data &&
                  adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    ? adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Personal Negotiated Fees</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.negotiated_fees
                    ? adjusters.carrier_adjuster.contact_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Company Negotiated Fees</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.negotiated_fees
                    ? adjusters.carrier_adjuster.company_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Company Guidelines</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.guidelines
                    ? adjusters.carrier_adjuster.company_data.guidelines
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Fees Paid out of</label>
              <div class="form-control-wrap">
                {{ housing_fee_type }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Pays Electronically</label>
              <div class="form-control-wrap">
                {{ pays_directly }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier will pay TPS Housing direct</label>
              <div class="form-control-wrap">
                {{ pays_electronically }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Accounting Notes</label>
              <div class="form-control-wrap">
                <p>{{ invoice.accounting_notes || "-" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["invoice", "placement", "adjusters", "budget", "property", "hotel"],
  data() {
    return {};
  },
  methods: {
    formatMoney(amount) {
      return window.formatMoney(amount);
    }
  },
  computed: {
    housing_fee_type() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const housing_fee_type = app.options.housing_fee_types.find(i => i.id == this.adjusters.carrier_adjuster.company_data.housing_fee_type_id);
        return housing_fee_type ? housing_fee_type.text : "-";
      }

      return "-";
    },
    pays_directly() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_directly = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_directly);
        return pays_directly ? pays_directly.text : "-";
      }

      return "-";
    },
    pays_electronically() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_electronically = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_electronically);
        return pays_electronically ? pays_electronically.text : "-";
      }

      return "-";
    }
  },
  mounted() {}
};
</script>

<style>
.swal2-content {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/payment-application-action.vue